function getPerkOfferFormFields(perks) {
    // Get the user's timezone
    const detectedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { 
        timeZone: detectedTimeZone, 
        hour12: false 
    });

    return [
        {
            id: 'offerType',
            type: 'dropdown',
            title: 'Offer type',
            config: {
                options: ["Perk", "FreeMembershipMonth", "DiscountOnMembership"]

            },
            help: '',
        },
        {
            id: 'titleLocalized',
            type: 'localized-text',
            title: 'Title',
            help: '',
        },
        {
            id: 'termsLocalized',
            type: 'localized-text',
            title: 'Terms',
            help: 'Terms for the offer',
        },
        {
            id: 'perkId',
            type: 'dropdown',
            title: 'Perk',
            config: {
                options: [...perks],
                optionLabel: 'name',
                optionValue: 'id',
                optionDisabled: (perk) => !perk.enabled,
                placeholder: 'Select perk',
            },
            help: '',
        },
        {
            id: 'amount',
            type: 'number-input',
            title: 'Amount',
            help: 'Amount of perks',
        },
        {
            id: 'iconUrl',
            type: 'imageUpload',
            title: 'Icon',
            help: '',
            accept: "image/svg+xml"
        },
        {
            id: 'isRedemptionTimeLimited',
            type: 'switch',
            title: 'Limit perk redemption hours',
            help: "When enabled, perk redemption will be restricted to specific hours"
        },
        {
            id: 'lockedFromTime',
            type: 'time-only',
            title: `🔒 Locked from time`,
            help: `Time when perk becomes unavailable for redemption in ${detectedTimeZone} (Current time: ${currentLocalTime})`,
            condition: 'isRedemptionTimeLimited'
        },
        {
            id: 'unlockedAtTime',
            type: 'time-only',
            title: `🔓 Unlocked at time`,
            help: `Time when perk becomes available again in ${detectedTimeZone} (Current time: ${currentLocalTime})`,
            condition: 'isRedemptionTimeLimited'
        },
        {
            id: 'timeZoneId',
            type: 'text-input',
            title: '🌍 Timezone',
            help: `Timezone for the redemption time control (auto-detected)`,
            config: {
                readonly: true,
            },
            condition: 'isRedemptionTimeLimited'
        },
    ]
}

var freeMembershipOfferFormFields = [
    {
        id: 'offerType',
        type: 'dropdown',
        title: 'Offer type',
        config: {
            options: ["Perk", "FreeMembershipMonth", "DiscountOnMembership"]

        },
        help: '',
    },

    {
        id: 'titleLocalized',
        type: 'localized-text',
        title: 'Title',
        help: '',
    },
    {
        id: 'termsLocalized',
        type: 'localized-text',
        config: {
            disabled: true,
        },
        title: 'Terms',
        help: 'Terms for the offer',
    },
    {
        id: 'amount',
        type: 'number-input',
        title: 'Number of free months',
        help: '',
    },
    {
        id: 'iconUrl',
        type: 'imageUpload',
        title: 'Icon',
        help: '',
        accept: "image/svg+xml, image/png"
    },
]

var discountOnMembershipOfferFormFields = [
    {
        id: 'offerType',
        type: 'dropdown',
        title: 'Offer type',
        config: {
            options: ["Perk", "FreeMembershipMonth", "DiscountOnMembership"]

        },
        help: '',
    },

    {
        id: 'titleLocalized',
        type: 'localized-text',
        title: 'Title',
        help: '',
    },
    {
        id: 'termsLocalized',
        type: 'localized-text',
        title: 'Terms',
        help: 'Terms for the offer',
    },
    {
        id: 'amount',
        type: 'number-input',
        title: 'Amount',
        help: 'Percent off next membership payment',
    },
    {
        id: 'iconUrl',
        type: 'imageUpload',
        title: 'Icon',
        help: '',
        accept: "image/svg+xml"
    },
]

export { getPerkOfferFormFields, freeMembershipOfferFormFields, discountOnMembershipOfferFormFields }